import { useTranslation } from "react-i18next";

import { useConfirmationDialogContext } from "../../confirmation-dialog/ConfirmationDialogContext";

/** Asks before a document is replaced by its PDF version; onConfirm runs only on agreement. */
export function useConvertToPdfConfirmation() {
  const { t } = useTranslation();
  const { showConfirmationDialog } = useConfirmationDialogContext();

  return (fileName: string, onConfirm: () => void) =>
    showConfirmationDialog({
      dialogTitleText: t("common.fileActions.convertToPdfConfirmTitle"),
      dialogText: t("common.fileActions.convertToPdfConfirmText", { fileName }),
      agreeText: t("common.fileActions.convertToPdfConfirm"),
      discardText: t("common.cancel"),
      showDiscardButton: true,
      onClose: (confirmed) => {
        if (confirmed) {
          onConfirm();
        }
      },
    });
}
